module.exports = __webpack_public_path__ + "img/chongci_ps_25.bc40a643.jpg";